module.exports = __webpack_public_path__ + "static/bicicletaAzul-bb19b56e431197119937c2ba561a7394.png";